import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, usePageMeta } from "@/components/site/PageHero";
import { Levels } from "@/components/site/Levels";
import { Services } from "@/components/site/Services";
import { CtaBand } from "@/components/site/CtaBand";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

export default function Trainings() {
  usePageMeta("Eğitimlerimiz", "Başlangıçtan ileri seviyeye enduro eğitimi ve çocuklar için motosiklet eğitimi — FX Motor Sporları, Çekmeköy / Ömerli.");
  return (
    <>
      <PageHero eyebrow="Eğitimlerimiz" title="Seviyene göre eğitim." intro="İlk kez motora binecek olandan tekniğini geliştirmek isteyen sürücüye kadar. Seviyeni birlikte belirler, programı eğitmenimizle sana göre kurarız." img="/ig/ig02.jpg" alt="Kumlu yokuşta eğitim sürüşü" crumbs={[{ label: "Eğitimlerimiz" }]} />
      <Services />
      <section className="mx-auto max-w-7xl border-t border-white/10 px-5 py-24 md:px-8 md:py-32">
        <Reveal className="mb-14">
          <Eyebrow>Eğitim seviyeleri</Eyebrow>
          <h2 className="max-w-3xl font-display text-5xl uppercase leading-none text-white md:text-7xl">Üç seviye, tek hedef: güvenle sürmek.</h2>
          <p className="mt-5 max-w-2xl text-neutral-400">Aşağıdaki başlıklar her seviyede çalıştığımız temel konulardır; ders süresi ve içerik, seviyene göre eğitmenimizle birlikte belirlenir.</p>
        </Reveal>
        <Levels />
      </section>
      <section data-testid="kids-training-section" className="border-t border-white/10 bg-surface">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 py-24 md:px-8 lg:grid-cols-2">
          <img src="/ig/ig12.jpg" alt="FX finish garajı önünde motosiklet" loading="lazy" className="aspect-[4/5] w-full max-w-md border border-white/10 object-cover" />
          <Reveal>
            <Eyebrow>Çocuk Eğitim</Eyebrow>
            <h2 className="font-display text-5xl uppercase leading-none text-white md:text-6xl">Motor sevgisi erken başlar.</h2>
            <p className="mt-5 max-w-lg text-neutral-400">Çocuklar için 5 derslik motosiklet eğitimi paketi — toplam 25.000 TL. Çocuğunuzun yaşı ve seviyesi için bize yazın; size uygun programı birlikte planlayalım.</p>
            <Link to="/egitimler/cocuk-egitim" data-testid="kids-training-link" className="group mt-8 inline-flex items-center gap-3 bg-brand px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">Çocuk eğitimi <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" /></Link>
          </Reveal>
        </div>
      </section>
      <CtaBand service="egitim" title="Eğitimine başla." />
    </>
  );
}
